import React from "react";
import { AnimateFrame } from "../../components/AnimateFrame";
import { ContactForm } from "../../components/ContactForm";
import { Header } from "../../components/Header";
import { Container } from "../../style/GlobalStyle";

export const Contacts = () => {
  return (
    <Container>
      <Header />
      <AnimateFrame>
        <ContactForm />
      </AnimateFrame>
    </Container>
  );
};
